export default {"src":"/_next/static/media/restaurants.9b471905.svg","height":77,"width":77,"blurWidth":0,"blurHeight":0};